// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { text } from '../../tokens/themeColors/text';
export var tablePaginationColors = function(mode) {
    var tx = text(mode);
    return {
        text: tx.primary
    };
};

//# sourceMappingURL=tablePaginationColors.js.map